import {
  getDataAcquisitionInstanceLog,
  GetSFMDisplay,
  GetRevocableDataTotals,
  addToDownloadCenter,
} from "@helpers/helpers";
import { pollReconciliationFile } from "@helpers/apiHelper.js";
import InfoModalStore from "@stores/InfoModalStore";
import SfmModalStore from "@stores/SfmModalStore";
import DownloadModalStore from "@stores/DownloadModalStore";
import {
  FIRST_INDEX,
  STORER_OPEN_TIMEOUT,
  STORER_HIGHLIGHT_TIMEOUT,
  ACTION_TYPES,
} from "./constants";

/**
 * Builds the actions configuration for the data table
 */
export const buildActions = (translate, store, onRevokeClick) => ({
  [ACTION_TYPES.VIEW_DETAILS]: {
    actionTypeTag: ACTION_TYPES.VIEW_DETAILS,
    name: translate("data-acquisition-instances.actions.VIEW_DETAILS"),
    actionFN: (row) => {
      getDataAcquisitionInstanceLog({
        DataAcquisitionInstanceId: row.original.DataAcquisitionInstanceId,
        callback: (data) => {
          if (data.DataAcquisitionLog !== null) {
            InfoModalStore.open({
              type: "Acquisition_Instances_Info",
              title: translate(
                "data-acquisition-instances.titles.INSTANCE_INFO"
              ),
              data: data.DataAcquisitionLog,
              show: true,
            });
          } else {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open({
              DetailedMessage: translate("shared.no-details-message"),
              Message: "SUCCESS",
              SfmTag: "SFM_SUCCESS",
              Type: 1,
              ShowMessage: true,
            });
          }
        },
        store,
      });
    },
    confirmation: false,
  },
  [ACTION_TYPES.REVOKE]: {
    actionTypeTag: ACTION_TYPES.REVOKE,
    name: translate("data-acquisition-instances.actions.REVOKE"),
    actionFN: (row) => {
      GetRevocableDataTotals(
        row.original.DataAcquisitionInstanceId,
        (data) => {
          const TotalPromotedRecords = data.TotalPromotedRecords;
          const TotalRevocableRecords = data.TotalRevocableRecords;
          onRevokeClick({
            DataAcquisitionInstanceId: row.original.DataAcquisitionInstanceId,
            TotalPromotedRecords,
            TotalRevocableRecords,
            message: translate(
              "data-acquisition-instances.confirmation-messages.REVOKE",
              {
                TotalRevocableRecords,
                TotalPromotedRecords,
              }
            ),
          });
        },
        store
      );
    },
  },
  [ACTION_TYPES.DOWNLOAD_RAW_DATA]: {
    actionTypeTag: ACTION_TYPES.DOWNLOAD_RAW_DATA,
    name: translate("data-acquisition-instances.actions.DOWNLOAD_RAW_DATA"),
    actionFN: (row) => {
      pollReconciliationFile(
        store,
        translate,
        "GetReconciliationFile",
        (data) => data.Files[FIRST_INDEX],
        (data, newPendingID) => {
          DownloadModalStore.open(STORER_OPEN_TIMEOUT);
          DownloadModalStore.highlight(STORER_HIGHLIGHT_TIMEOUT, newPendingID);
        },
        "DataAcquisition",
        "DATA_ACQUISITION_RAW_DATA",
        "DataAcquisitionInstanceId",
        row.original.DataAcquisitionInstanceId.toString(),
        "Raw Data"
      );
    },
    confirmationMessage: translate(
      "data-acquisition-instances.confirmation-messages.DOWNLOAD_RAW_DATA"
    ),
    confirmation: true,
  },
  [ACTION_TYPES.DOWNLOAD_FAULTY_RECORDS]: {
    actionTypeTag: ACTION_TYPES.DOWNLOAD_FAULTY_RECORDS,
    name: translate(
      "data-acquisition-instances.actions.DOWNLOAD_FAULTY_RECORDS"
    ),
    actionFN: (row) => {
      pollReconciliationFile(
        store,
        translate,
        "GetReconciliationFile",
        (data) => data.Files[FIRST_INDEX],
        (data, newPendingID) => {
          DownloadModalStore.open(STORER_OPEN_TIMEOUT);
          DownloadModalStore.highlight(STORER_HIGHLIGHT_TIMEOUT, newPendingID);
        },
        "DataAcquisition",
        "DATA_ACQUISITION_FAULTY_DATA",
        "DataAcquisitionInstanceId",
        row.original.DataAcquisitionInstanceId.toString(),
        "Faulty Data"
      );
    },
    confirmationMessage: translate(
      "data-acquisition-instances.confirmation-messages.DOWNLOAD_FAULTY_RECORDS"
    ),
    confirmation: true,
  },
  [ACTION_TYPES.DOWNLOAD_REVOKED_RECORDS]: {
    actionTypeTag: ACTION_TYPES.DOWNLOAD_REVOKED_RECORDS,
    name: translate(
      "data-acquisition-instances.actions.DOWNLOAD_REVOKED_RECORDS"
    ),
    actionFN: (row) => {
      pollReconciliationFile(
        store,
        translate,
        "GetReconciliationFile",
        (data) => data.Files[FIRST_INDEX],
        (data, newPendingID) => {
          DownloadModalStore.open(STORER_OPEN_TIMEOUT);
          DownloadModalStore.highlight(STORER_HIGHLIGHT_TIMEOUT, newPendingID);
        },
        "DataAcquisition",
        "DATA_ACQUISITION_REVOKED_DATA",
        "DataAcquisitionInstanceId",
        row.original.DataAcquisitionInstanceId.toString(),
        "Revoked Data"
      );
    },
    confirmationMessage: translate(
      "data-acquisition-instances.confirmation-messages.DOWNLOAD_REVOKED_DATA"
    ),
    confirmation: true,
  },
});
